export function applyTransferenceSelection(transferenceSelected, code, item, isChecked) {
  const updatedSelection = { ...transferenceSelected };
  if (isChecked) {
    updatedSelection[code] = item;
  } else {
    delete updatedSelection[code];
  }
  return updatedSelection;
}

export function applyTransferenceStatus(transferenceListStatus, transferenceId, status) {
  return {
    ...transferenceListStatus,
    [transferenceId]: status,
  };
}
